<template>
  <div class="login-container min-container">
    <div class="loading-mask" v-if="loading">
      <loading
        :box-size="14"
        :round-size="3"
        :color="'#306fff'"></loading>
    </div>
    <div class="login-wrap"
         v-if="!$store.state.hasToken"
         :style="`background: #fff url('${theme.background_url ? theme.background_url : bg}') no-repeat top left / 520px 600px;`">
      <h2>{{theme.name ? theme.name : '全国青少年编程能力测评系统'}}</h2>
      <div class="form-box">
        <account-login v-if="tab==='account'" ref="loginDom" @focusInput="focusInput"></account-login>
        <phone-login v-if="tab==='phone'" ref="loginDom" @focusInput="focusInput"></phone-login>
        <national-login v-if="isNationalTest" ref="loginDom" @focusInput="focusInput" @resetError="resetErrorTips"></national-login>
        <div v-if="isNationalTest && showErrorTips" class="error-msg">输入信息有误，请核实后重新输入!</div>
        <countdown-btn
          ref="loginBtn"
          el="button"
          type="submit"
          class="login-btn"
          :style="'background:'+theme.buttonBackground+'box-shadow: '+theme.buttonShadow"
          placeholder="登录"
          lockTmp="%s秒"
          clickTips="请稍后"
          @click="login"></countdown-btn>
        <div v-if="!isChongQing && !isNationalTest">
          <span class="switch-link" :style="'color:'+theme.themeColor" v-if="tab==='account'" @click="change('phone')">手机号登录</span>
          <span v-else class="switch-link" :style="'color:'+theme.themeColor" @click="change('account')">账号登录</span>
          <!--<p class="title">第三方登录</p>-->
          <!--<div class="login-type">-->
            <!--<span class="qq" @click="third_login('qq')"></span>-->
            <!--<span class="weChat" @click="third_login('wechat')"></span>-->
          <!--</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountdownBtn from '@/components/CountdownBtn'
import AccountLogin from './AccountLogin'
import PhoneLogin from './PhoneLogin'
import NationalLogin from './NationalLogin.vue'
import { mapMutations } from 'vuex'
import { get, post } from '@/utils/ajax'
import { getTouristsVal } from '@/utils'
import Loading from '@/components/Loading'
import { loginEvent } from '@/utils/sensor'
import { getNatialPath } from '@/utils/common'
import { Base64 } from 'js-base64'
import tips from '@/assets/json/errorTips'
export default {
  components: {
    CountdownBtn,
    AccountLogin,
    PhoneLogin,
    NationalLogin,
    Loading
  },
  data () {
    return {
      tab: '',
      bg: 'http://public-static-edu.codemao.cn/test/login.png',
      account: '',
      // 是否是新国赛
      isNationalTest: false,
      loading: false,
      showErrorTips: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    testInfo () {
      return this.$store.state.testInfo
    },
    theme () {
      return this.$store.state.theme
    },
    isChongQing() {
      const path = sessionStorage.getItem('path')
      const arr = ['chongqingceshi', 'chongqing', 'cqmn']
      return arr.includes(path)
    },
    // 是否是山东科协
    isShandongKexie() {
      return window.location.href.indexOf(CONFIG.shandongkexie) !== -1
    }
  },
  watch: {
    // 返回不会生效
    '$store.state.hasToken' (n, o) {
      if (n && this.$store.state.user.id && !this.testInfo.exam_id) {
        this.getTestInfo()
      }
    }
  },
  async mounted () {
    const isTourists = getTouristsVal()
    if (isTourists) {
      this.$router.push({ name: 'list' })
    }
    // 返回生效
    if (!this.user && this.$store.state.hasToken) {
      await this.$store.dispatch('getCodemaoUserInfo')
    }
    if (this.$store.state.hasToken && !this.$store.state.route.params.goLogin) {
      await this.getTestInfo()
    }
    const natialPath = getNatialPath(CONFIG.env)
    if (window.location.href.indexOf(natialPath) !== -1) {
      this.isNationalTest = true
      return
    }
    this.tab = 'account'
  },
  methods: {
    ...mapMutations({
      setUser: 'SET_USER',
      setExaminee: 'SET_EXAMINEE_INFO'
    }),
    resetErrorTips() {
      this.showErrorTips = false
    },
    focusInput (event) {
      event.target.parentNode.querySelector('input').focus()
    },
    async login(lock, reset) {
      reset()
      await this.$refs.loginDom.validationTouch()
      if (this.isNationalTest) { // 新国赛
        this.nationalLogin()
        return
      }
      try {
        if (this.tab === 'account') {
          const identity = `${this.isShandongKexie ? 'K' : ''}${this.$refs.loginDom.form.account.trim()}`
          // 弹出验证码
          this.$verify({
            identity: identity,
            dom_id: 'countdownBtn',
            success_callback: this.captchaSuccess,
            fail_callback: reset,
            close_callback: reset
          })
        } else {
          this.phoneLogin()
        }
      } catch (e) {
        if (++this.errorNum >= 5) {
          this.errorNum = 'password'
          localStorage.setItem('loginCountdownBtn', +new Date() + 60 * 1000)
          this.$message.error('操作频繁，请1分钟后再试！')
          lock()
        }
        if (this.tab === 'account') {
          this.$refs.loginDom.form.password = ''
        } else {
          this.$refs.loginDom.form.code = ''
        }
      }
    },
    async handleLoginNext(auth) {
      localStorage.examId = ''
      this.$store.commit('HAS_TOKEN', true)
      const user = {}
      user.weakPassword = auth.is_weak_password
      this.setUser(user)
      const userInfo = await this.$auth('get_profile')
      this.$store.commit('SET_USER', userInfo)
      localStorage.setItem('user_id', userInfo.id)
      loginEvent(userInfo)
      // 加逻辑判断自动排考
      await this.goAutomatic()
      await this.getTestInfo()
    },
    // 账号登录，成功获取通用图形验证码ticket，登录
    async captchaSuccess(ticket, appid) {
      this.loading = true
      try {
        const { account, password } = this.$refs.loginDom.form
        const username = `${this.isShandongKexie ? 'K' : ''}${account.trim()}`
        const res = await this.$auth('login_account_ticket', ...[username, password, 'egLIJPgY', ticket])
        localStorage.setItem('currentAccount', username)
        await this.handleLoginNext(res.auth)
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    // 手机验证码登录
    async phoneLogin () {
      this.loading = true
      const { phone, code } = this.$refs.loginDom.form
      try {
        const res = await this.$auth('login_phone', ...[phone, code])
        this.$refs.loginDom.form.code = ''
        localStorage.setItem('currentAccount', '')
        await this.handleLoginNext(res.auth)
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    // 新国赛登陆
    async nationalLogin() {
      this.loading = true
      const { account, username } = this.$refs.loginDom.form
      const params = {
        account: `hxth${account}`,
        password: Base64.encode(username.trim())
      }
      try {
        const res = await this.$auth('login_account', ...[params.account, params.password])
        localStorage.setItem('currentAccount', account)
        await this.handleLoginNext(res.auth)
        this.loading = false
      } catch (e) {
        if (e === 'USER_NOT_EXIST_OR_PWD_WRONG') {
          this.showErrorTips = true
        } else {
          if (tips[e] === 'Network Error') {
            this.$message.error('网络异常')
          } else {
            const tip = tips[e] || e || '未知错误，重新登录或联系管理员'
            this.$message.error(tip)
          }
        }
        this.loading = false
      }
    },
    async goAutomatic () {
      if (this.theme.is_automatic && !this.theme.arrange) {
        await post('/home/sites/auto/arrange', { address: location.origin + '/' + location.href.split('/')[3], name: this.user.fullname || localStorage.currentAccount || this.user.nickname, userId: this.user.id })
      }
    },
    async getTestInfo () {
      let siteId = ''
      if (this.theme.id) {
        siteId = `&site_id=${this.theme.id}`
      }
      let id = this.user.id
      if (!this.user.id) {
        const userInfo = await this.$auth('get_profile')
        id = userInfo.id
      }
      try {
        const { exam_id, only_exam, identity_verification, exam_config } = await get(`/home/edu/examinees/${id}/check/only?exam_type=2${siteId}`)
        if (!only_exam) { // 多场考试
          this.$router.push({ name: 'list' })
        } else {
          const examNoticeConfig = exam_config.find(item =>
            item.label === 'LARGE_EXAM#exam_notice'
          )
          const openExamNotice = examNoticeConfig && examNoticeConfig.actual_value === '1'
          if (this.theme.deviceCheckOpen || identity_verification === 1 || openExamNotice) { // 若这场考试需要设备检测/身份核验/考前须知，到列表页
            this.$router.push({ name: 'list' })
          } else { // 否则直接进入考试候考页
            localStorage.examId = exam_id
            this.$message.success('你有一场待参加的考试即将转入……')
            setTimeout(() => {
              this.$router.push({ name: 'pretest' })
            }, 2000)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    change (item) {
      this.tab = item
    },
    third_login(type) {
      this.$store.commit('sdk/changeItem', { key: 'toggleLogin', value: false })
      const prefix = 'https://www.codemao.cn'
      const wxappId = 'wxeda82dc272f7fe92'
      const qqappId = '101253342'
      const redirect_uri = `${window.location.protocol}//${window.location.host}/${location.href.split('/')[3]}/thirdLogin`
      const state = 'test'
      let url = ''
      if (type === 'qq') {
        url = `${prefix}/get-qq-code.html?appid=${qqappId}&redirect_uri=${redirect_uri}`
      } else {
        url = `${prefix}/get-weixin-code.html?appid=${wxappId}&scope=snsapi_login&state=${state}&redirect_uri=${redirect_uri}`
      }
      // 改跳转
      const new_window = window.open(url, 'newwindow', 'height=690, width=600, top=200, left=300, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no')
      let timer = ''
      const get_user_info = function () {
        if (new_window.closed) {
          clearInterval(timer)
          localStorage.setItem('currentAccount', '')
          window.location.reload()
        }
      }
      timer = setInterval(get_user_info, 1000)
    }
  }
}
</script>

<style lang="scss">
.login-container {
  width: 100%;
  height: 100%;
  background-color: $backgroundColor;
  display: flex;
  align-items: center;
}
.login-wrap {
  width: 1160px;
  height: 600px;
  border-radius: 8px;
  box-shadow: 0 0 30px 0 rgba(57, 126, 253, .1);
  margin: 0 auto;
  padding: 68px 0 0 520px;
  // background: #fff url('~images/login.png') no-repeat top left / 580px 600px;
  h2 {
    margin-bottom: 60px;
    text-align: center;
  }
  .form-box {
    width: 360px;
    margin: 0 auto;
  }
}
.login-wrap .ipt-group {
  width: 360px;
  height: 65px;
  margin-bottom: 20px;
  padding-top: 24px;
  position: relative;
  &.mb60 {
    margin-bottom: 60px;
  }
  &.error {
    .line {
      width: 100%;
      background-color: red;
    }
    .error-tip {
      display: block;
      padding: 5px 0;
    }
  }
  .error-tip {
    color: #F5222D;
    font-size: 14px;
    display: none;
  }
  .sub-text {
    position: absolute;
    bottom: 4px;
    left: 0;
    color: #999;
    margin-bottom: 4px;
    line-height: 20px;
    transition: bottom .2s ease-in-out;
    font-size: 16px;
    &.has-text {
      bottom: 40px;
    }
  }
  .line {
    width: 0;
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    transition: width .2s ease-in-out;
  }
  input {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid $lineColor;
    box-shadow: 0 0 0px 1000px white inset !important;
    background: none;
    box-shadow: none;
    outline: none;
    color: #333;
    font-size: 16px;
    &:focus + .sub-text{
      bottom: 40px;
    }
    &:focus + .sub-text + .line {
      width: 100%;
    }
  }
  .focus-input + .sub-text +  .line {
      width: 100%;
  }
  .focus-input + .sub-text {
    bottom: 40px;
  }
}
.login-wrap .code-group {
  width: 210px;
}
.error-msg {
  font-size: 14px;
  color: #f00;
  text-align: center;
  width: 360px;
  margin-bottom: 20px;
}
.login-wrap .login-btn {
  background: $buttonBackground;
  box-shadow: $buttonShadow;
  display: block;
  color: #fff;
  width: 360px;
  height: 46px;
  padding: 10px 0;
  font-size: 18px;
  border-radius: 4px;
  text-align: center;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: $themeColor;
  }
  &.disabled {
    background: #d8d8d8;
    box-shadow: none;
    cursor: default;
    color: #fff;
  }
}
</style>

<style lang="scss" scoped>
.switch-link {
  cursor: pointer;
  display: inline-block;
  color: $themeColor;
  font-size: 14px;
  margin-top: 20px;
}
.title {
  width: 360px;
  color: #999;
  font-size: 12px;
  line-height: 30px;
  font-weight: 300;
  text-align: center;
  margin: 33px 0 15px;
  &:before , &:after {
    content: '';
    display: inline-block;
    width: 100px;
    height: 1px;
    background: #E2E2E2;
    vertical-align: middle;
  }
  &:before {
    margin-right: 15px;
  }
  &:after {
    margin-left: 15px;
  }
}
.login-type {
  text-align: center;
  width: 360px;
  span {
    width: 36px;
    height: 36px;
    display: inline-block;
    margin: 0 29px;
    cursor: pointer;
  }
  .qq {
    background: url('~@/assets/images/login/icon_qq.png') no-repeat center / cover;
  }
  .weChat {
    background: url('~@/assets/images/login/icon_wechat.png') no-repeat center / cover;
  }
}
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, .2);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
